// Functions are used in a way they cannot be always after initialization
/* eslint-disable @typescript-eslint/no-use-before-define */
import { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { executeLogout, modalClose, modalShow, showGrowlNotification } from '../../store/actions';
import VerifyPhoneNumber from './VerifyPhoneNumber';
import EnterPasscode from './EnterPasscode';
import ExitVerificationFlow from './ExitVerificationFlow';
import { useTranslation } from 'react-i18next';
import { startPhoneNumberVerification } from '../../utils';

interface PhoneNumberVerificationFlowContainerProps {
  phoneNumber: string;
}

const PhoneNumberVerificationFlowContainer: FunctionComponent<PhoneNumberVerificationFlowContainerProps> = ({ phoneNumber }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('phoneNumberVerification');

  useEffect(() => {
    const openExitVerification = () => {
      dispatch(
        modalShow(
          t('ExitVerificationFlow.title'),
          t('ExitVerificationFlow.exitButton'),
          t('ExitVerificationFlow.goBackButton'),
          () => {
            dispatch(modalClose());
            dispatch(executeLogout());
          },
          () => openVerifyPhoneNumberFlow(),
          <ExitVerificationFlow />,
        ),
      );
    };

    const openVerifyPhoneNumberPasscode = (verificationId: string) => {
      dispatch(
        modalShow(
          t('EnterPasscode.title'),
          '',
          '',
          () => {},
          () => openExitVerification(),
          <EnterPasscode phoneNumber={phoneNumber} verificationId={verificationId} openVerifyPhoneNumberFlow={openVerifyPhoneNumberFlow} />,
        ),
      );
    };

    const openVerifyPhoneNumberFlow = () => {
      dispatch(
        modalShow(
          t('VerifyPhoneNumber.title'),
          t('VerifyPhoneNumber.nextButton'),
          '',
          async () => {
            const verificationData = await startPhoneNumberVerification();
            if (verificationData) {
              openVerifyPhoneNumberPasscode(verificationData.id);
            } else {
              dispatch(showGrowlNotification(t('passcodeRequestErrorNotification'), 'error'));
              openVerifyPhoneNumberFlow();
            }
          },
          () => openExitVerification(),
          <VerifyPhoneNumber phoneNumber={phoneNumber} />,
        ),
      );
    };

    openVerifyPhoneNumberFlow();
  }, [dispatch, t, phoneNumber]);

  return <></>;
};

export default PhoneNumberVerificationFlowContainer;
